import { useTranslation } from 'react-i18next';
import { useOrganizations } from '@/hooks/useOrganizations';
import { OrganizationRole } from '@/types/gql.generated';
import { Center, Spinner, Text } from '@/ui';
import { PanelContent } from '../../components/PanelContent';
import { PanelHeader } from '../../components/PanelHeader';
import { useSettingsModal } from '../../store';
import { EditableOrganizationName } from './components/EditableOrganizationName';
import { OrganizationPanel } from './components/OrganizationPanel';

// Shows whichever org is selected in the settings sidebar; SettingsModal's
// guard effect keeps the selection pointing at a real membership.
export const Organizations = () => {
  const { t } = useTranslation('settingsModal', {
    keyPrefix: 'organizations',
  });
  const { sharedOrganizations, isLoading, isError } = useOrganizations();
  const { organizationId } = useSettingsModal();
  const organization =
    sharedOrganizations.find((org) => org.id === organizationId) ?? null;
  const isOwner = organization?.role === OrganizationRole.Owner;

  return (
    <>
      <PanelHeader>
        {organization &&
          (isOwner ? (
            <EditableOrganizationName organization={organization} />
          ) : (
            organization.name
          ))}
      </PanelHeader>
      <PanelContent>
        {isLoading ? (
          <Center py="10">
            <Spinner />
          </Center>
        ) : isError ? (
          <Text color="customgray.mid">{t('error')}</Text>
        ) : !organization ? null : (
          <OrganizationPanel
            key={organization.id}
            organization={organization}
          />
        )}
      </PanelContent>
    </>
  );
};
